//import React from "react";
import React, { useEffect, useContext } from 'react';
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';

// @material-ui/core | components 
import { makeStyles } from "@material-ui/core/styles";
import PermIdentity from "@material-ui/icons/PermIdentity";
import CircularProgress from '@material-ui/core/CircularProgress';
import Checkbox from "@material-ui/core/Checkbox";
import Check from "@material-ui/icons/Check";
import TextField from "@material-ui/core/TextField"
import Tooltip from "@material-ui/core/Tooltip";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import Select from 'react-select';
import Autocomplete from '@material-ui/lab/Autocomplete';

// services
import { MaskCPF, MaskCel, MaskDecimal } from "beaktShared/helpers/masks";
import { SessionContext } from "beaktShared/services/session";
import { UseGetApiSimple } from "beaktShared/services/crudeApiService";

// styles
import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import stylesMaterial from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

const useStyles = makeStyles(styles);
const useStylesMaterial = makeStyles(stylesMaterial);

export default function GestaoAnamneseForm({ clienteId, estabelecimentoId, handleView, addItem, loading }) {
    const { t } = useTranslation();
    const { register, handleSubmit, setValue, errors } = useForm({mode: "onChange"});
    const classes = useStyles();
    const classesMaterial = useStylesMaterial();
    const session = useContext(SessionContext);
    const endPoint = "LayoutAnamnese/";

    // LayoutsAnamnese = 'Layout DoutorDM2 Diabetes'
    useEffect(() => {
        loadFichaQuestionroAnamnese();
    }, []);


    const [notification, setNotification] = React.useState({
        show:false,
        color:'info',
        message:''
    });

    const showNotification = (message,color) => { 
        setNotification({
        show:true,
        color:color,
        message:message      
        });
        setTimeout(function() {
        setNotification({show:false});
        }, 6000);       
    };


    
    const handleRespostaChange = (layoutAnamnesePerguntaId, layoutAnamneseRespostaId, valorResposta, isChecked) => {
        setRespostaQuestionario(prevPerguntas => {
            const perguntaExistente = prevPerguntas.find(pergunta => pergunta.layoutAnamnesePerguntaId === layoutAnamnesePerguntaId);

            if (perguntaExistente) {
                let novasRespostas;
                if (isChecked) {
                    // Adiciona a resposta se isChecked for verdadeiro
                    novasRespostas = perguntaExistente.tipoResposta === 0
                        ? [{ layoutAnamneseRespostaId, valorResposta }]
                        : [...perguntaExistente.respostas, { layoutAnamneseRespostaId, valorResposta }];
                } else {
                    // Remove a resposta se isChecked for falso
                    novasRespostas = perguntaExistente.respostas.filter(resposta =>
                        resposta.layoutAnamneseRespostaId !== layoutAnamneseRespostaId
                    );
                }

                return prevPerguntas.map(pergunta =>
                    pergunta.layoutAnamnesePerguntaId === layoutAnamnesePerguntaId
                        ? { ...pergunta, respostas: novasRespostas }
                        : pergunta
                );
            }
        });
    };
    
    const [itensLoading, setItensLoading] = React.useState(false);
    const [descricaoForm, setDescricaoForm] = React.useState("Anamnese");
    const [layoutAnamneseId, setLayoutAnamneseId] = React.useState(0);
    const [questionario, setQuestionario] = React.useState({});
    const [respostaQuestionario, setRespostaQuestionario] = React.useState({});
    const [controlaCheckbox, setControleQuestionario] = React.useState({});
    const loadFichaQuestionroAnamnese = () => {
        setItensLoading(true);

        let endPointGet = endPoint + "Anamnese DoutorDM2 Diabetes";
        UseGetApiSimple(endPointGet, 0).then(result => {
            if(result.status !== 200)
            {
                showNotification(result.message,'danger');  
                setItensLoading(false);
                return false; 
            }
            
            setLayoutAnamneseId(result.data.layoutAnamneseId);
            setDescricaoForm(result.data.descricao);
            setQuestionario(result.data.layoutAnamnesePergunta);

            const layoutAnamnesePerguntaIds = result.data.layoutAnamnesePergunta.map(pergunta => ({
                layoutAnamnesePerguntaId: pergunta.layoutAnamnesePerguntaId,
                tipoResposta: pergunta.tipoResposta,
                obrigatorio: pergunta.obrigatorio,
                respostas: []
            }));
            setRespostaQuestionario(layoutAnamnesePerguntaIds);

            const controle = result.data.layoutAnamnesePergunta.map(pergunta => ({
                layoutAnamnesePerguntaId: pergunta.layoutAnamnesePerguntaId,
                tipoResposta: pergunta.tipoResposta,
                respostas: pergunta.layoutAnamneseResposta.map(resposta => ({
                    layoutAnamneseRespostaId: resposta.layoutAnamneseRespostaId,
                    isChecked: false,
                })),
            }));
            setControleQuestionario(controle);

            setItensLoading(false);
        });
    }

    const handleViewForm = () => {
        handleView(true);
    };

    const [respostasSelecionadas, setRespostasSelecionadas] = React.useState([]);
    const handleChangeCheck = (event, layoutAnamnesePerguntaId, layoutAnamneseRespostaId) => {
        event.preventDefault();
        const isChecked = event.target.checked;

        setControleQuestionario(prevControle => {
            return prevControle.map(pergunta => {
                if (pergunta.layoutAnamnesePerguntaId === layoutAnamnesePerguntaId) {
                    // Atualiza o estado de isChecked da resposta correspondente
                    pergunta.respostas.forEach(resposta => {
                        if (resposta.layoutAnamneseRespostaId === layoutAnamneseRespostaId) {
                            resposta.isChecked = isChecked;
                        } else if (pergunta.tipoResposta === 0) {
                            // Se a pergunta permitir apenas uma resposta, desmarca as outras
                            resposta.isChecked = false;
                        }
                    });
                }
                return pergunta;
            });
        });

        const respostasSelecionadas = controlaCheckbox.reduce((acc, pergunta) => {
            pergunta.respostas.forEach(resposta => {
                if (resposta.isChecked) {
                    acc.push(resposta.layoutAnamneseRespostaId);
                }
            });
            return acc;
        }, []);

        setRespostasSelecionadas(respostasSelecionadas);

        handleRespostaChange(layoutAnamnesePerguntaId, layoutAnamneseRespostaId, '', isChecked);
    }

    const handleChangeTextField = (layoutAnamnesePerguntaId, layoutAnamneseRespostaId, event) => {
        handleRespostaChange(layoutAnamnesePerguntaId, layoutAnamneseRespostaId, event.target.value, true);
    }
    
    const onSubmit = (data, e) => {

        var respostasFicha = [];
        if (respostaQuestionario.length > 0)
        {
            respostaQuestionario.forEach(item => {
                // Verifica se o item tem a propriedade 'respostas'
                if (item.respostas && item.respostas.length > 0) {
                    // Itera sobre as respostas do item
                    item.respostas.forEach(resposta => {
                        // Extrai as informações desejadas e adiciona ao novo array
                        respostasFicha.push({
                            LayoutAnamneseRespostaId: resposta.layoutAnamneseRespostaId,
                            ValorResposta: resposta.valorResposta
                        });
                    });
                }
            });            
        }

        var FichaAnamnese = {
            UsuarioCadastroId: session.id,
            EstabelecimentoId: session.estabelecimentoId,
            ClienteId: clienteId,
            LayoutAnamneseId: layoutAnamneseId,
            FichaAnamneseRespostas: respostasFicha,
        }

        addItem(FichaAnamnese);
    }

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)}>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="primary" icon>
                                <CardIcon color="primary">
                                    <PermIdentity />
                                </CardIcon>
                                <h4 className={classes.cardIconTitle}>
                                    {descricaoForm}
                                </h4>
                            </CardHeader>
                            <CardBody style={{minHeight:'400px'}}>
                                {itensLoading && 
                                    <div className="loadingVenda">
                                        <CircularProgress />
                                        <br/>
                                        <label>{t('sale.loading_itens')}...</label>
                                    </div>
                                }

                                <GridContainer>
                                    {
                                        questionario.length > 0 && 
                                        questionario.map(perguntas => (
                                            perguntas.ordem === 1 ?
                                            (
                                                <>
                                                    <GridItem xs={12} sm={12} md={12} key={perguntas.layoutAnamnesePerguntaId} style={{ padding : '0' }}>
                                                        <div className={classes.modalQuestion}>
                                                        <h5 style={{ fontWeight: 'bold', textTransform: 'uppercase', color: '#5d5d5d', fontSize: '0.875rem' }}>
                                                            {perguntas.descricao}
                                                        </h5>
                                                        <div style={{ display: 'Flex', flexWrap: 'wrap', gap: '10px', paddingBottom: '10px' }}>
                                                        {   
                                                            perguntas.layoutAnamneseResposta.length > 0  && 
                                                            perguntas.layoutAnamneseResposta.map(respostas => (
                                                                <>
                                                                    <div 
                                                                        key={respostas.layoutAnamneseRespostaId}
                                                                        style={{ display: "flex", alignItems: "center" }}
                                                                        className="checkboxmi">
                                                                        <Checkbox
                                                                            tabIndex={-1}
                                                                            id={respostas.layoutAnamneseRespostaId}
                                                                            onChange={event => {
                                                                                handleChangeCheck(
                                                                                    event, 
                                                                                    perguntas.layoutAnamnesePerguntaId, 
                                                                                    respostas.layoutAnamneseRespostaId,
                                                                                );
                                                                            }}
                                                                            checked={respostasSelecionadas.includes(respostas.layoutAnamneseRespostaId)}
                                                                            checkedIcon={<Check className={classesMaterial.checkedIcon} />}
                                                                            icon={<Check className={classesMaterial.uncheckedIcon} />}
                                                                            classes={{ checked: classesMaterial.checked }}                    
                                                                            name={"ck_" + perguntas.layoutAnamnesePerguntaId + "_" + respostas.layoutAnamneseRespostaId}
                                                                        />
                                                                        <label style={{ marginTop: "0.625rem", color: "#373737" }}>
                                                                            {respostas.descricao}
                                                                        </label>
                                                                    </div>
                                                                </>
                                                            ))
                                                        }
                                                        </div>
                                                        </div>
                                                    </GridItem>
                                                </>
                                            ) :
                                            (
                                                <>
                                                    <GridItem xs={12} sm={6} md={6} key={perguntas.layoutAnamnesePerguntaId} style={{ padding : '0' }}>
                                                        <div className={classes.modalQuestion}>
                                                            <h5 style={{ fontWeight: 'bold', textTransform: 'uppercase', color: '#5d5d5d', fontSize: '0.875rem' }}>
                                                                {perguntas.descricao}
                                                            </h5>
                                                            {
                                                                <>
                                                                    {
                                                                        perguntas.textoOrientacao !== "" && 
                                                                        <span style={{ color: "#787878", fontStyle: "italic" }}>
                                                                            {perguntas.textoOrientacao}
                                                                        </span>
                                                                    }
                                                                    {
                                                                        perguntas.layoutAnamneseResposta.length > 1 ?
                                                                        (
                                                                            perguntas.layoutAnamneseResposta.map(respostas => (
                                                                            <div>
                                                                                <hr />
                                                                                <div 
                                                                                    key={respostas.layoutAnamneseRespostaId}
                                                                                    style={{ display: "flex", alignItems: "center" }}
                                                                                    className="checkboxmi">
                                                                                    <Checkbox
                                                                                        tabIndex={-1}
                                                                                        id={respostas.layoutAnamneseRespostaId}
                                                                                        onChange={event => {
                                                                                            handleChangeCheck(
                                                                                                event, 
                                                                                                perguntas.layoutAnamnesePerguntaId, 
                                                                                                respostas.layoutAnamneseRespostaId,
                                                                                            );
                                                                                        }}
                                                                                        checked={respostasSelecionadas.includes(respostas.layoutAnamneseRespostaId)}
                                                                                        checkedIcon={<Check className={classesMaterial.checkedIcon} />}
                                                                                        icon={<Check className={classesMaterial.uncheckedIcon} />}
                                                                                        classes={{ checked: classesMaterial.checked }}                    
                                                                                        name={"ck_" + perguntas.layoutAnamnesePerguntaId + "_" + respostas.layoutAnamneseRespostaId}
                                                                                    />
                                                                                    <label style={{ marginTop: "0.625rem", color: "#373737" }}>
                                                                                        {respostas.descricao}
                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                            ))
                                                                        ) :
                                                                        (
                                                                            perguntas.layoutAnamneseResposta.length === 1 &&
                                                                            <>
                                                                                <TextField
                                                                                    fullWidth
                                                                                    variant="outlined"
                                                                                    multiline={true}
                                                                                    inputProps={{maxLength: 512}}
                                                                                    name={"tf_" + perguntas.layoutAnamnesePerguntaId + "_" + perguntas.layoutAnamneseResposta[0].layoutAnamneseRespostaId}
                                                                                    onChange={handleChangeTextField.bind(null, perguntas.layoutAnamnesePerguntaId,  perguntas.layoutAnamneseResposta[0].layoutAnamneseRespostaId)}
                                                                                 />
                                                                            </>
                                                                        )
                                                                    }
                                                                </>
                                                            }
                                                        </div>
                                                    </GridItem>
                                                </>
                                            )
                                        ))
                                    }
                                </GridContainer>


                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>

                <GridContainer>
                    <GridItem xs={12} sm={12} md={12} className={classes.textCenter}>
                        <Button onClick={() => handleViewForm()} color="#efefef" className={classes.updateProfileButton}>
                            {t('button.cancel')}
                        </Button>
                        <Button type="submit" color="primary" className={classes.updateProfileButton}>
                            {t('button.to_save')}
                            {loading && <div>{t('label.loading') + "..."}</div>}
                        </Button>
                    </GridItem>
                </GridContainer>
            </form>
        </>
    );
}